import React, { lazy, Suspense } from "react";
import { CustomRoutes } from "react-admin";
import { Route } from "react-router-dom";

import SpecialTools from "./SpecialTools";
import LiveWindow from "./LiveWindow";
import BulkUploadKeywords from "./BulkUploadKeywords";
import MyProfile from "./MyProfile";
import Analytics from "./Analytics";

import { withValidPlanShow } from "./DataHooks/useSubscription";

// Lazy-loaded components
const FBCommentExtractor = lazy(() =>
  import("./CommentExtract/FBCommentExtractor")
);
const IGCommentExtractor = lazy(() =>
  import("./CommentExtract/IGCommentExtractor")
);
const FBConversations = lazy(() => import("./MessengerChat/Conversations"));
const IGConversations = lazy(() => import("./MessengerChat/IGConversations"));
const NewFacebookCallback = lazy(() =>
  import("./SocialLink/NewFacebookCallback")
);
const OrderScanner = lazy(() => import("./OrderScanner/Scanner"));
const SubscriptionBilling = lazy(() => import("./SubscriptionBilling"));
const Accounts = lazy(() => import("./Accounts"));
const MarketingMessages = lazy(() => import("./MarketingMessages"));
const CombineOrders = lazy(() => import("./CombineOrders"));
const BulkUploadUpdateOrder = lazy(() => import("./BulkUploadUpdateOrder"));
const EventManager = lazy(() => import("./EventManager/PanelTab"));

// Wrapped components
const VSpecialTools = withValidPlanShow(SpecialTools);
const VMyProfile = withValidPlanShow(MyProfile);
const VAnalytics = withValidPlanShow(Analytics);
const VFBCommentExtractor = withValidPlanShow(FBCommentExtractor);
const VIGCommentExtractor = withValidPlanShow(IGCommentExtractor);

export default (
  <CustomRoutes>
    <Route
      path="/auth/facebook/callback"
      element={
        <Suspense fallback="Loading...">
          <NewFacebookCallback />
        </Suspense>
      }
    />
    <Route path="/special-tools" element={<VSpecialTools />} />
    <Route path="/live-window" element={<LiveWindow />} />
    <Route
      path="/marketing-messages"
      element={
        <Suspense fallback="Loading...">
          <MarketingMessages />
        </Suspense>
      }
    />
    <Route
      path="/fb-comment-manager"
      element={
        <Suspense fallback="Loading...">
          <VFBCommentExtractor />
        </Suspense>
      }
    />
    <Route
      path="/ig-comment-manager"
      element={
        <Suspense fallback="Loading...">
          <VIGCommentExtractor />
        </Suspense>
      }
    />
    <Route
      path="/bulk-upload-tracking-number"
      element={
        <Suspense fallback="Loading...">
          <BulkUploadUpdateOrder />
        </Suspense>
      }
    />
    <Route path="/bulk-upload-keywords" element={<BulkUploadKeywords />} />
    <Route
      path="/combine-orders"
      element={
        <Suspense fallback="Loading...">
          <CombineOrders />
        </Suspense>
      }
    />
    <Route path="/settings" element={<VMyProfile />} />
    <Route
      path="/qr-scanner"
      element={
        <Suspense fallback="Loading...">
          <OrderScanner />
        </Suspense>
      }
    />
    <Route path="/analytics" element={<VAnalytics />} />
    <Route
      path="/billing"
      element={
        <Suspense fallback="Loading...">
          <SubscriptionBilling />
        </Suspense>
      }
    />
    <Route
      path="/accounts"
      element={
        <Suspense fallback="Loading...">
          <Accounts />
        </Suspense>
      }
    />
    <Route
      path="/fb-conversations"
      element={
        <Suspense fallback="Loading...">
          <FBConversations />
        </Suspense>
      }
    />
    <Route
      path="/ig-conversations"
      element={
        <Suspense fallback="Loading...">
          <IGConversations />
        </Suspense>
      }
    />
    <Route
      path="/event-manager"
      element={
        <Suspense fallback="Loading...">
          <EventManager />
        </Suspense>
      }
    />
  </CustomRoutes>
);
